import type { CommissionsPage } from '../types';
import { getCreators } from './creators-api';
import type { BookingsDto } from './creators-api.types';
import { mapBookingsDto } from './dashboard.mapper';

// Payout's History shows the first page; "See all" and "Show more" load the
// rest a page at a time. The API's pages are numbered for a fixed size, so it
// stays the same for every page.
const PAGE_SIZE = 5;

/** A page of History. `cursor` is a page's `nextCursor`; null for the first. */
export async function fetchCommissions(
	cursor: string | null = null,
): Promise<CommissionsPage> {
	const page = cursor ? Number(cursor) : 0;
	return mapBookingsDto(
		await getCreators<BookingsDto>('bookings', { page, size: PAGE_SIZE }),
	);
}
